import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import { Homepage } from "./pages/Homepage";
import { Shop } from "./pages/Shop";
import { SingleProduct } from "./pages/SingleProduct";
import { ErrorPage } from "./pages/404";
import { About } from "./pages/About";
import { Cart } from "./pages/Cart";
import { Checkout } from "./pages/Checkout";
import { Contact } from "./pages/Contact";
import { Wishlist } from "./pages/Wishlist";
import { Signup } from "./pages/Signup";
import { Login } from "./pages/Login";
import { ClientLayout } from "./layouts/ClientLayout";

import { Profile } from "./pages/Profile";
import { AddressBook } from "./pages/AddressBook";
import { PaymentMethods } from "./pages/PaymentMethods";
import { UserOrders } from "./pages/UserOrders";
import { UserOrderDetails } from "./pages/UserOrderDetails";
import { AccountLayout } from "./layouts/AccountLayout";

import { AdminSignup } from "./admin/AdminSignup"
import { AdminLogin } from "./admin/AdminLogin";
import { AdminDashboard } from "./admin/pages/AdminDashboard"
import { AdminProducts } from "./admin/pages/AdminProducts"
import { AdminOrders } from "./admin/pages/AdminOrders"
import { AdminProduct } from "./admin/pages/AdminProduct";
import { OrderDetails } from "./admin/pages/OrderDetails";
import { Customers } from "./admin/pages/Customers";
import { Customer } from "./admin/pages/Customer";
import { AdminLayout } from "./layouts/AdminLayout";

import "./app.css";
import "./styles/layout.css";

function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className="App">

      <Routes>
        
        <Route path="/adminSignup" element={<AdminSignup />} />
        <Route path="/adminLogin" element={<AdminLogin />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/products/add" element={<AdminProduct />} />
          <Route path="/admin/products/:id/edit" element={<AdminProduct />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/orders/:id" element={<OrderDetails />} />
          <Route path="/admin/customers" element={<Customers />} />
          <Route path="/admin/customers/:id" element={<Customer />} />
        </Route>

        <Route path="/" element={<ClientLayout />}>
          <Route index element={<Homepage />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:id" element={<SingleProduct />} />
          <Route path="/about" element={<About />} />
          <Route path="/account" element={<AccountLayout />}>
            <Route index element={<Profile />} />
            <Route path="/account/addressBook" element={<AddressBook />} />
            <Route path="/account/payment" element={<PaymentMethods />} />
            <Route path="/account/orders" element={<UserOrders />} />
            <Route path="/account/deliveries" element={<UserOrders />} />
            <Route path="/account/returns" element={<UserOrders />} />
            <Route path="/account/cancellations" element={<UserOrders />} />
            <Route path="/account/orders/:id" element={<UserOrderDetails />} />
          </Route>
          <Route path="/cart" element={<Cart />} />
          <Route path="/cart/checkout" element={<Checkout />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
        
      </Routes>

    </div>
  );
}

export default App;